import { PropsWithChildren, useEffect, useRef } from 'react'
import posthog from 'posthog-js'
import { PostHogProvider as PHProvider } from 'posthog-js/react'

import { getPostHogApiHost } from '@percent/utility'
import { useAuth } from '@percent/workplace-giving/common/hooks/useAuth/useAuth'
import {
  getAccountFromAuthState,
  getPartnerFromAuthState
} from '@percent/workplace-giving/context/auth/authContextController/AuthContextController'

export function PostHogProvider({ children }: PropsWithChildren) {
  const apiKey = process.env.NX_PUBLIC_POSTHOG_API_KEY
  const initialized = useRef(false)
  const { state: authState } = useAuth()
  const account = getAccountFromAuthState(authState)
  const partner = getPartnerFromAuthState(authState)

  useEffect(() => {
    if (!apiKey) return

    if (!initialized.current) {
      posthog.init(apiKey, {
        api_host: getPostHogApiHost(window.location.hostname),
        ui_host: 'https://eu.posthog.com',
        capture_pageview: false,
        capture_pageleave: false,
        autocapture: false,
        disable_session_recording: true,
        person_profiles: 'identified_only'
      })
      posthog.register({ app: 'workplace-giving' })
      initialized.current = true
    }

    if (account?.id && partner?.id) {
      posthog.identify(account.id, { partnerId: partner.id })
    } else {
      posthog.reset()
    }
  }, [apiKey, account?.id, partner?.id])

  if (!apiKey) return <>{children}</>

  return <PHProvider client={posthog}>{children}</PHProvider>
}
